<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="min-height: 200px;"
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <h1 class="display-2 text-white">Hello {{getUser.fullName}} </h1>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="#">
                    <img
                      :src="getUser.picture"
                      class="rounded-circle"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div
              class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
            >
            </div>
            <div class="card-body pt-0 pt-md-4">
              <!--div class="row">
                <div class="col">
                  <div
                    class="card-profile-stats d-flex justify-content-center mt-md-5"
                  >
                    <div>
                      <span class="heading">0</span>
                      <span class="description">Friends</span>
                    </div>
                    <div>
                      <span class="heading">0</span>
                      <span class="description">Photos</span>
                    </div>
                    <div>
                      <span class="heading">0</span>
                      <span class="description">Comments</span>
                    </div>
                  </div>
                </div>
              </div-->
            </div>
          </div>
        </div>

        <div class="col-xl-8 order-xl-1">
          <card shadow type="secondary">
            <template v-slot:header>
              <div class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">My account</h3>
                  </div>
                </div>
              </div>
            </template>

            <form id=account-form role="form" @submit.prevent="handleForm(!v$.$invalid)" novalidate>
              <h6 class="heading-small text-muted mb-4">Change password</h6>
              <div class="pl-lg-4">
                <base-alert type="danger" class="mt-3 mb-3" v-if="errorMessage">
                {{errorMessage}}  
                </base-alert>
                <base-alert type="success" class="mt-3 mb-3" v-if="showSuccess">
                Your password has been successfully updated!
                </base-alert>
                <base-input
                      placeholder="Current password"
                      label="Current password"
                      v-model="v$.model.currentPassword.$model"
                      type="password"
                      :valid="isValid(v$.model.currentPassword)"
                      :error="v$.model.currentPassword.$error && v$.model.currentPassword.$errors[0].$message"
                />
                <base-input
                      placeholder="New password"
                      label="New password"
                      v-model="v$.model.password.$model"
                      type="password"
                      :valid="isValid(v$.model.password)"
                      :error="v$.model.password.$error && v$.model.password.$errors[0].$message"
                />
              </div>
              <div class="text-right">
                <base-button nativeType="submit" type="primary" class="my-4" :disabled="loading">Save</base-button>
              </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required, minLength  } from '@vuelidate/validators'

export default {
  name: "user-profile",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      loading: false,
      isSubmitted: false,
      errorMessage: '',
      showSuccess: false,
      model: {
        currentPassword: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  validations() {
    return {
        model: {
            currentPassword: {required}, 
            password: {required, minLength: minLength(8) }
        } 
    } 
  },
  methods: {
    handleForm(isValid) {
      this.isSubmitted = true;

      if (!isValid) return;

      this.loading = true;
      this.errorMessage = false;
      this.$resources.users
      .update(this.getUser.id, this.model)
      .then( () => {
        this.loading = false;
        this.showSuccess = true;
      }, (error) => {
        this.loading = false;
        if (error.response && error.response.data && error.response.data) {
          this.errorMessage = error.response && error.response.data && error.response.data['hydra:description']; 
        }
      });

    },
    isValid(item){
        if (!this.isSubmitted){
          return null;
        } 

        return !item.$invalid;
    }
  } 
};
</script>
<style></style>
